import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

import * as styles from "./styles.module.css";

const Stat = ({ number, pretext, posttext, color = "red" }) => {
  const { ref, inView } = useInView({ threshold: 0.3, triggerOnce: true });
  const colorClass = color === "teal" ? styles.teal : styles.red;

  return (
    <div className={`${styles.number} ${colorClass}`} ref={ref}>
      <>
        {pretext}
        {inView ? <CountUp end={number} duration={0.75} /> : null}
        {posttext}
      </>
    </div>
  );
};

export default Stat;
